import { AxiosAdapter } from "../commons/adapters";

const http = new AxiosAdapter();

const BASE_URL = '/v1/ratings/service-rating-links';

export const getLinksEncuestasService = async (page: number = 1, status?: number) => {
    try {
        const query = status !== undefined ? `&status=${status}` : '';
        return await http.get<any>(`${BASE_URL}?page=${page}&take=10${query}`);
    } catch (error: any) {
        if (error && !error.ok) {
            return error;
        }
        console.log('getLinksEncuestasService ', error);
    }
}

export const getLinksEncuestasBySearchService = async (term: string, page: number = 1, status?: number) => {
    try {
        const query = status !== undefined ? `&status=${status}` : '';
        return await http.get<any>(`${BASE_URL}?page=${page}&take=10&search=${term}${query}`);
    } catch (error: any) {
        if (error && !error.ok) {
            return error;
        }
        console.log('getLinksEncuestasBySearchService ', error);
    }
}

export const createLinkEncuestaService = async (data: object, onUploadProgress?: any) => {
    try {
        return await http.postLogin<any>(BASE_URL, data);
    } catch (error: any) {
        if (error && !error.ok) {
            return error;
        }
        console.log('createLinkEncuestaService ', error);
    }
}

export const getLinkEncuestaDetailService = async (id: string) => {
    try {
        return await http.get<any>(`${BASE_URL}/${id}`);
    } catch (error: any) {
        if (error && !error.ok) {
            return error;
        }
        console.log('getLinkEncuestaDetailService ', error);
    }
}

export const updateLinkEncuestaService = async (id: string, data: object) => {
    try {
        return await http.put<any>(`${BASE_URL}/${id}`, data);
    } catch (error: any) {
        if (error && !error.ok) {
            return error;
        }
        console.log('updateLinkEncuestaService ', error);
    }
}

export const deleteLinkEncuestaService = async (id: string, term: string = '', page: number = 1, status?: number) => {
    try {
        const query = status !== undefined ? `&status=${status}` : '';
        return await http.delete<any>(`${BASE_URL}/${id}?page=${page}&search=${term}${query}`);
    } catch (error: any) {
        if (error && !error.ok) {
            return error;
        }
        console.log('deleteLinkEncuestaService ', error);
    }
}

export const restoreLinkEncuestaService = async (id: string, term: string = '', page: number = 1, status?: number) => {
    try {
        const query = status !== undefined ? `&status=${status}` : '';
        return await http.patchTable<any>(`${BASE_URL}/${id}/restore?page=${page}&search=${term}${query}`);
    } catch (error: any) {
        if (error && !error.ok) {
            return error;
        }
        console.log('restoreLinkEncuestaService ', error);
    }
}
